import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../material.module';

// Standalone Components (import and export)
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';

// Standalone Pipes (all pipes are now standalone)
import { PhonePipe } from './pipes/phone.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeSvgPipe } from './pipes/safe-svg.pipe';
import { ProfilePicturePipe } from './pipes/profile-picture.pipe';
import { AbsoluteValuePipe } from './pipes/absolute-value.pipe';
import { ElapsedTimePipe } from './pipes/elapsed-time.pipe';
import { NullPipe } from './pipes/null.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';
import { HoursMinutesPipe } from './pipes/hours-minutes.pipe';
import { SdHighlightTextPipe } from './pipes/highlight.pipe';
import { SdRoundValuePipe } from './pipes/round-value.pipe';

// Standalone Directives (all directives are now standalone)
import { MatchHeightDirective } from './directives/match-height.directive';
import { PasswordMatchDirective } from './directives/password-match.directive';

// Standalone items - import AND export
const STANDALONE_COMPONENTS = [ConfirmDialogComponent, PhoneInputComponent];

const STANDALONE_PIPES = [
  PhonePipe,
  SafeHtmlPipe,
  SafeSvgPipe,
  ProfilePicturePipe,
  AbsoluteValuePipe,
  ElapsedTimePipe,
  NullPipe,
  PercentagePipe,
  HoursMinutesPipe,
  SdHighlightTextPipe,
  SdRoundValuePipe,
];

const STANDALONE_DIRECTIVES = [MatchHeightDirective, PasswordMatchDirective];

// Non-standalone items - declare AND export
const COMPONENTS: never[] = [];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    // Import standalone items
    ...STANDALONE_COMPONENTS,
    ...STANDALONE_PIPES,
    ...STANDALONE_DIRECTIVES,
  ],
  declarations: [
    // Only declare non-standalone items
    ...COMPONENTS,
  ],
  exports: [
    // Re-export common modules for convenience
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    // Export all items (both standalone and non-standalone)
    ...STANDALONE_COMPONENTS,
    ...STANDALONE_PIPES,
    ...STANDALONE_DIRECTIVES,
    ...COMPONENTS,
  ],
})
export class SharedModule {}
